import * as Contacts from "./contacts";
import * as Paths from "./paths";

export * from "./api";
export * from "./notifications";
export * from "./ssr";

export {
    Contacts,
    Paths,
};

export const AllowedImageUploadExtns = ["bmp", "jpg", "jpeg", "gif", "png"];



// WEBPACK FOOTER //
// ./src/constants/index.ts